var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
export const FTLTableBody = React.forwardRef((_a, ref) => {
    var { showHeader = false, showFooter = false, className = "" } = _a, otherProps = __rest(_a, ["showHeader", "showFooter", "className"]);
    const { root } = useStyles({ showHeader, showFooter });
    return (React.createElement("tbody", Object.assign({ ref: ref, className: className + " " + root }, otherProps)));
});
const useStyles = makeStyles({
    root: ({ showHeader, showFooter, }) => ({
        "& > tr:last-child": {
            "&:before, &:after": showHeader || showFooter
                ? {
                    content: "@",
                    display: "block",
                    lineHeight: 4,
                    textIndent: -99999,
                }
                : {},
        },
    }),
});
//# sourceMappingURL=FTLTableBody.js.map